import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import styleHelper from '@utils/styleHelper';
import { Fonts, Spacings, breakpoints } from '@styles/index';

const H1 = styled.h1`
  font-weight: ${Fonts.BOLD};
  font-size: ${Fonts.H1};
  line-height: ${Fonts.HEADER_LINE_HEIGHT};
  color: ${({ color }) => color};
  margin: ${Spacings.SPACING_0B};
  @media only screen and (max-width: ${breakpoints.tablet}) {
    font-size: 24px;
  }
  @media only screen and (max-width: ${breakpoints.mobile}) {
    font-size: 28px;
    line-height: 120%;
  }
  ${({ lineClamp }) =>
    lineClamp ? styleHelper.lineClampStyle(lineClamp) : null}
`;

export default H1;

H1.propTypes = {
  color: PropTypes.string,
  lineClamp: PropTypes.number
};

H1.defaultProps = {
  color: 'var(--color-text-primary)',
  lineClamp: null
};
